import { reactive, toRefs, computed } from 'vue'
import { timerTask } from '@/utils/timer'
import { queryNotice, postNoticeReaded } from '@/services/api/common'
import { defineStore } from '../store'
import eventBus from '@/services/bus'

/**
 * 系统通知存储对象
 */
export const useNoticeStore = defineStore(() => {
    const state = reactive({
        loading: false,
        noticeList: <Model.NoticeRsp[]>[], // 通知列表
    })

    // 未读列表
    const unreadList = computed(() => {
        return state.noticeList.filter((e) => !e.readed)
    })

    // 强制显示列表
    const tipsList = computed(() => {
        return state.noticeList.filter((e) => e.isforcedisplay)
    })

    // 获取通知列表
    const getNoticeList = async () => {
        try {
            state.loading = true
            timerTask.clearTimeout('systemNotice')
            const res = await queryNotice()
            state.noticeList = res.data
        } finally {
            state.loading = false
            // 轮询查询系统通知
            timerTask.setTimeout(() => {
                getNoticeList()
            }, 60 * 1000, 'systemNotice')
        }
    }

    // 更新已读
    const updateNoticeReaded = (id: number) => {
        const item = state.noticeList.find((e) => e.autoid === id)
        if (item && !item.readed) {
            postNoticeReaded({
                data: {
                    noticeID: id,
                }
            }).then(() => {
                item.readed = true
            })
        }
    }

    // 接收登入请求数据
    eventBus.$on('LoginNotify', () => {
        getNoticeList()
    })

    // 接收登出通知清空数据
    eventBus.$on('LogoutNotify', () => {
        timerTask.clearTimeout('systemNotice')
        state.noticeList = []
    })

    return {
        ...toRefs(state),
        unreadList,
        tipsList,
        getNoticeList,
        updateNoticeReaded,
    }
})